import React, { useEffect, useState } from 'react';

import './search-input.scss';
import { Form, Icon } from '@ampol/design-system';
import { debounce } from 'lodash';

interface SearchInputProps {
  // eslint-disable-next-line no-unused-vars
  onSearch: (value: string) => void;
  debounceTime?: number;
  className?: string;
  placeHolder?: string;
  hasFocus?: boolean;
  defaultValue?: string;
  searchSchema: any;
  triggerValidation?: boolean;
}

const SearchInput = ({ 
  onSearch, 
  debounceTime=300, 
  className, 
  placeHolder, 
  hasFocus, 
  defaultValue, 
  searchSchema, 
  triggerValidation= false 
}: SearchInputProps) => {
  const [searchValue, setSearchValue] = useState(defaultValue);
  const debouncedSearch = React.useRef(
    debounce((query) => {
      onSearch && onSearch(query);
    }, debounceTime)
  ).current;

  // Cancel debounced search on unmount
  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const searchHandler = (values) => {
    const { searchTerm } = values;

    setSearchValue(searchTerm);
    debouncedSearch(searchTerm);
  };

  const clearhandler = () => {
    setSearchValue('');
    onSearch && onSearch('');
  };

  useEffect(() => {
    setSearchValue(defaultValue);
  }, [defaultValue]);

  return <>
    <div className={`search-input ${className}`}>
      <Form
        schema={searchSchema ?? {}}
        onChange={searchHandler}
        defaultValues={{ searchTerm: searchValue }}
        triggerValidation={triggerValidation}
      >
        <Form.Input
          label = ''
          inputSuffix={!searchValue || searchValue.length === 0
            ? <div className="search-input__icon"><Icon url="/icons/search.svg" /></div>
            : <div>
              <button className="search-input__close" aria-label="clear search"
                onClick={clearhandler} type="button"
              >
                <Icon url="/icons/close.svg" />
              </button>
            </div>
          }
          autoComplete={'off'}
          name="searchTerm"
          placeholder={placeHolder ?? 'Search'}
          type="text"
          disabled={false}
          style={ { width: '100%' } }
          hasFocus={hasFocus}
          className='search-input__field'
        />
      </Form>
    </div>
  </>;
};

export default SearchInput;
